import React from 'react'
import { CompanyMedalCardsDashboardMainDivV2 } from '../styles'
import PropTypes from 'prop-types';
import { ImageUrl } from '../../../utils/constants';
import { RewardsHorizontalLine } from '../../../utils/icons';
import { TIER_STYLES } from '../../../../mockData';

function MedalCard({tier}) {

  const tierStyle = TIER_STYLES[tier?.tier_name.toLowerCase()]
  
  return (
    <React.Fragment>

      <CompanyMedalCardsDashboardMainDivV2 background={tierStyle?.background} textColor={tierStyle?.text} borderColor={tierStyle?.border}>
        <div className="cardDiv">
          <div className='cardFirstRow'>
            <div className="cardDetails">
              <div className="cardTitle">
                {tier?.tier_name} 
              </div>
            </div>
            <div className="cardImage" style={{
              marginTop: (tier?.tier_name?.toLowerCase() === "platinum" || tier?.tier_name?.toLowerCase() === "gold")  && "-7px"
            }}>
              <img src={ImageUrl + `/images/Rewards/new-${tier?.tier_name?.toLowerCase()}.png`}   style={{
                transform: tier?.tier_name?.toLowerCase() === "platinum" ? "rotate(180deg)" : "none"
              }}/>
            </div>
          </div>

          <div className="cardFourthRow">
            <span className='coloredText'>{tier?.users_achieved}</span>
            <span className='normalText'> Users Achieved</span>
          </div>  


          <div className="cardThirdRow">
            {RewardsHorizontalLine()}
            {/* <hr /> */}
          </div>
          <div className='cardSecondRow'>
            <div className="cardPoints">
              <span className='coloredPoints'>{tier?.tier_points} Points</span>
              {/* <span>Points</span> */}
            </div>
          </div>
        </div>
      </CompanyMedalCardsDashboardMainDivV2>
    </React.Fragment>
    
  )
}

MedalCard.propTypes = {
  tier: PropTypes.object,
};

export default MedalCard
